import { SVGProps } from 'react';

export const WifiError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="67"
    height="65"
    viewBox="0 0 67 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.9622 48.0372C30.4052 48.0372 29.1365 46.7684 29.1365 45.2115C29.1365 43.6545 30.4052 42.3858 31.9622 42.3858C33.5192 42.3858 34.7879 43.6545 34.7879 45.2115C34.7879 46.7684 33.5192 48.0372 31.9622 48.0372M31.9622 36.7344C27.2885 36.7344 23.4851 40.5378 23.4851 45.2115C23.4851 49.8852 27.2885 53.6886 31.9622 53.6886C36.6359 53.6886 40.4393 49.8852 40.4393 45.2115C40.4393 40.5378 36.6359 36.7344 31.9622 36.7344"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.9651 22.6094C25.9265 22.6094 20.2525 24.9632 15.9829 29.2328L19.9813 33.2284C23.18 30.024 27.4383 28.2608 31.9651 28.2608C36.4947 28.2608 40.7502 30.024 43.9545 33.2284L47.9501 29.2328C43.6804 24.9632 38.0036 22.6094 31.9651 22.6094"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.9444 17.2396L63.9399 13.2441C55.4007 4.70196 44.047 0 31.97 0C19.8929 0 8.53927 4.70196 0 13.2441L3.99554 17.2396C11.4667 9.76562 21.4019 5.6514 31.97 5.6514C42.5353 5.6514 52.4733 9.76562 59.9444 17.2396"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.948 25.239L55.9436 21.2435C42.7221 8.02206 21.2129 8.02488 7.99146 21.2407L11.987 25.2362C23.0044 14.2245 40.9306 14.2245 51.948 25.239"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.6971 31.0859C49.4636 31.0859 44.3943 36.1552 44.3943 42.3887H50.0457C50.0457 39.272 52.5803 36.7373 55.6971 36.7373C58.8138 36.7373 61.3485 39.272 61.3485 42.3887C61.3485 45.5055 58.8138 48.0401 55.6971 48.0401H52.8714V56.5172H58.5228V53.3355C63.3915 52.0752 66.9999 47.6445 66.9999 42.3887C66.9999 36.1552 61.9306 31.0859 55.6971 31.0859"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.6973 59.3359C54.1375 59.3359 52.8716 60.6019 52.8716 62.1616C52.8716 63.7214 54.1375 64.9873 55.6973 64.9873C57.2571 64.9873 58.523 63.7214 58.523 62.1616C58.523 60.6019 57.2571 59.3359 55.6973 59.3359"
      fill="currentColor"
    />
  </svg>
);
